// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__VzUG_","errorLogs":"EditorFooter_errorLogs__16QK0"};